import { render, staticRenderFns } from "./RoteirizacaoMotoristasjornada.vue?vue&type=template&id=0976cc1a&scoped=true&"
import script from "./RoteirizacaoMotoristasjornada.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoMotoristasjornada.vue?vue&type=script&lang=js&"
import style0 from "./RoteirizacaoMotoristasjornada.vue?vue&type=style&index=0&id=0976cc1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976cc1a",
  null
  
)

export default component.exports